import React, { Fragment, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { CommonSvg } from "../SVG";
import { DOWNLAOD_MULTIPLE_ASSET } from "../../DAM_API/urls";
import { toast } from "react-toastify";
import Axios from "../../../utils/Axios";

const FolderGridSecondVersion = ({
  Data,
  EllipseActions,
  Title = "Folder 1",
  Index = 0,
  isSelected,
  HandleSelect,
  isFolder = false,
  onUpload,
}) => {
  const navigate = useNavigate();
  const { comSlug } = useParams();

  /* ---------------- Mobile Detection ---------------- */
  const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

  /* ---------------- Long Press Refs ---------------- */
  const longPressTimer = useRef(null);
  const LONG_PRESS_DELAY = 500;

  /* ---------------- Select ---------------- */
  const handleSelect = () => {
    HandleSelect?.({ Image: Data, Key: 1 });
  };

  /* ---------------- Open ---------------- */
  const handleOpen = () => {
    if (isFolder) {
      HandleSelect?.({ Image: Data, Key: 4 });
    } else {
      navigate(`/${comSlug}/folder/${Data?.id}`);
    }
  };

  /* ---------------- Desktop Click ---------------- */
  const handleMouseClick = (e) => {
    if (isMobile) return;
    if (e.button === 0 && !e.ctrlKey && !e.shiftKey) {
      HandleSelect?.({ Image: Data, Key: 1 });
    }

    if (e.shiftKey && e.button === 0) {
      HandleSelect?.({ Image: Data, Key: 3 });
    }

    if (e.ctrlKey && !e.shiftKey) {
      HandleSelect?.({ Image: Data, Key: 2 });
    }
  };

  /* ---------------- Desktop Double Click ---------------- */
  const handleDoubleClick = () => {
    if (isMobile) return;
    handleOpen();
  };

  /* ---------------- Mobile Touch Start ---------------- */
  const handleTouchStart = () => {
    if (!isMobile) return;

    longPressTimer.current = setTimeout(() => {
      handleSelect(); // HOLD → Select
      longPressTimer.current = null;
    }, LONG_PRESS_DELAY);
  };

  /* ---------------- Mobile Touch End ---------------- */
  const handleTouchEnd = () => {
    if (!isMobile) return;

    if (longPressTimer.current) {
      clearTimeout(longPressTimer.current);
      longPressTimer.current = null;
      handleOpen(); // tap
    }
  };

  /* ---------------- Download ---------------- */
  const handeldownload = async () => {
    try {
      const response = await Axios.post(
        DOWNLAOD_MULTIPLE_ASSET,
        { folderId: [Data?.id] },
        { responseType: "blob" }
      );

      const blob = response.data;
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;

      const contentDisposition = response.headers["content-disposition"];
      let filename = "images.zip";
      if (contentDisposition) {
        const match = contentDisposition.match(/filename="(.+)"/);
        if (match) filename = match[1];
      }

      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      toast.error("Download Failed");
    }
  };

  return (
    <Fragment>
      <div
        tabIndex={Index}
        className={`dam_common_hover ${isSelected ? "dam_selected_design" : ""
          } _dam_folder_common_container_toggle`}
        style={{
          position: "relative",
          borderRadius: "8px",
        }}
        onClick={handleMouseClick}
        onDoubleClick={handleDoubleClick}
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
      >
        <div className="">
          <div className="d-flex align-items-center gap-3">
            <div className="w-10">
              {CommonSvg.folderIconSvg}
            </div>
            <div className="_dam_folder_common_title">{Title}</div>
          </div>

          {/* Actions (optional)
          <div
            onClick={(e) => {
              e.stopPropagation();
              handeldownload();
            }}
          >
            {EllipseActions}
          </div>
          */}
        </div>
      </div>
    </Fragment>
  );
};

export default FolderGridSecondVersion;
